var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_7114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6.17969C9.73476 6.17965 10.4533 6.39545 11.0665 6.80031C11.6797 7.20517 12.1604 7.78123 12.4489 8.45696C12.7375 9.13268 12.8212 9.87829 12.6896 10.6012C12.558 11.3241 12.217 11.9924 11.7089 12.5231C11.2007 13.0538 10.5479 13.4236 9.8314 13.5864C9.11492 13.7493 8.36638 13.6981 7.67875 13.4391C6.99113 13.1802 6.39471 12.725 5.96359 12.13C5.53247 11.535 5.28564 10.8265 5.25375 10.0924L5.25 9.92969L5.25375 9.76694C5.29569 8.8015 5.70871 7.88952 6.40667 7.22118C7.10463 6.55284 8.03365 6.17974 9 6.17969Z",
    fill: "#14BA6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_7114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.929688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessChip);
export default __webpack_public_path__ + "static/media/successChip.748125ab5f6aa5153316e84d737847cb.svg";
export { ForwardRef as ReactComponent };